import { useContext } from "react";
import { GroupsContext } from "contexts/GroupsContext";

// ==============================|| CONFIG - HOOKS  ||============================== //

const useGroups = () => useContext(GroupsContext);

export default useGroups;
